import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm';

class GalleryService {
    #gallery;

    constructor() {
        this.#gallery = new PhotoSwipeLightbox({
            pswpModule: PhotoSwipe
        });
        this.#gallery.on('change', () => {
            let photoSwipe = this.#gallery.pswp;
            let currSlide = photoSwipe.currSlide;

            if (currSlide.data.width > 1 && currSlide.data.height > 1) {
                return;
            }

            let image = new Image();
            image.src = currSlide.data.src;

            image.onload = () => {
                currSlide.data.width = image.width;
                currSlide.data.height = image.height;
                photoSwipe.refreshSlideContent(photoSwipe.currIndex);
            };
        });
        this.#gallery.init();
    }


    open(index, dataSource) {
        dataSource.forEach(item => {
            if ((item.width && item.height) || !item.src) {
                return;
            }

            item.width = 1;
            item.height = 1;
        });
        this.#gallery.loadAndOpen(index, dataSource);
    }

    onListOpen(item, list, img, attr=null) {
        $(document).on('click', img, (e) => {
            const gallery = [];
            const $item = $(e.target.closest(item));
            $item.closest(list)
                .find(img)
                .each(function () {
                    const $this = $(this);
                    gallery.push({src: attr ? $this.attr(attr) : $this.data('src') || $this.prop('src')})
                });
            this.open($item.index(item), gallery);
        });
    }
}

export default new GalleryService();